import { ImpBanner as SingleImpBanner } from "@faire/retailer-visitor-shared/components/Notifications/Components/Conductor/ImpBanner";
import { useGetBannerContentByViewport } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/useGetBannerContentByViewport";
import { IProductMessageByViewport } from "@faire/web-api--source/indigofair/retailer/IProductMessageByViewport";
import React from "react";

interface IProps {
  banner: IProductMessageByViewport;
}

export const ImpBanner: React.FC<IProps> = ({ banner }) => {
  const { bannerContents } = useGetBannerContentByViewport([banner]);

  if (!bannerContents[0]) {
    return null;
  }

  return <SingleImpBanner message={bannerContents[0]} />;
};
